import { ConfigurationError } from '@cian/peperrors/shared';

import { ATTRIBUTE_INSTANCE_ID } from '../../../shared/constants/index.js';

import type { MicrofrontendNS } from '../../../shared/microfrontend/index.js';
import type { IUIInstance } from '../../instance/interfaces.js';
import type { RegistryComponent } from '../../registryComponent/index.js';
import type { IInstanceContext } from '../context/index.js';

export class UIInstance implements IUIInstance {
  public readonly id: MicrofrontendNS.InstanceId;

  private readonly tagName: string;
  private readonly context: IInstanceContext;
  private _customElement: RegistryComponent | undefined;

  public constructor(id: MicrofrontendNS.InstanceId, tagName: string, context: IInstanceContext) {
    this.id = id;
    this.tagName = tagName;
    this.context = context;
  }

  public get isCustomElementCreated(): boolean {
    return !!this._customElement;
  }

  public get customElement(): RegistryComponent {
    if (!this._customElement) {
      this._customElement = document.createElement(this.tagName) as RegistryComponent;
      this._customElement.setAttribute(ATTRIBUTE_INSTANCE_ID, this.id);
    }

    return this._customElement;
  }

  public set customElement(customElement: RegistryComponent) {
    if (this._customElement) {
      throw new ConfigurationError({
        message: `Элемент уже установлен в экземпляре`,
        domain: 'mf-registry.browser.instance.ui',
        details: { image: this.context.image.version, runtime: this.context.runtime.name, id: this.id },
      });
    }

    this._customElement = customElement;
  }

  public destroy(): void {
    // TODO: удаление Instance из Runtime

    this._customElement = undefined;
  }
}
